import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  form: {
    display: 'grid',
    gap: theme.spacing(4),
  },
}));
